<div
  class="container slide-in-left"
  [class.container-toggled]="toggleService.isToggled"
  (mouseleave)="toggleService.toggleSidebar()"
  (mouseenter)="toggleService.toggleSidebar()"
>
  <div class="termhub-logo-text" (click)="navigateToTH()" [class.logo-toggled]="toggleService.isToggled">
    <span *ngIf="!toggleService.isToggled">
      <img src="../../assets/automapai-logo.png" alt="AutomapAI" height="70" title="{{ server_version }}" />
    </span>
    <span *ngIf="toggleService.isToggled">
      <img src="../../assets/automapai-logo.png" alt="AutomapAI" height="30" title="{{ server_version }}" />
    </span>
  </div>

  <ng-container [ngSwitch]="server_environment">
    <div *ngSwitchCase="'localhost'" class="banner text-white local page-h1-font"></div>
    <div *ngSwitchCase="'demo'" class="banner text-white dev page-h1-font"></div>
    <div *ngSwitchCase="'uat'" class="banner text-white uat page-h1-font"></div>
    <div *ngSwitchCase="'training'" class="banner text-white training page-h1-font"></div>
    <div *ngSwitchDefault class="banner text-white d-none page-h1-font"></div>
  </ng-container>

  <div class="sidebar-menu-items">
    <div>
      <div class="menu-item-main">
        <div class="d-flex align-items-center" [routerLink]="['/automap']" [routerLinkActive]="['active']">
          <div class="icon" title="AutomapAI">
            <mat-icon class="sidebar-icon material-icons-outlined">map</mat-icon>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">AutomapAI</div>
        </div>
      </div>
      <div class="menu-item-main" *ngIf="this.isAdmin">
        <div class="d-flex align-items-center" [routerLink]="['/admin']" [routerLinkActive]="['active']">
          <div class="icon" title="AutomapAI">
            <mat-icon class="sidebar-icon material-icons-outlined">settings</mat-icon>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Admin</div>
        </div>
      </div>
      <div class="menu-item-main" *ngIf="this.isAdmin">
        <div class="d-flex align-items-center" [class]="location.path().includes('/users') ? 'active active-fill' : ''" [routerLink]="['/users']">
          <div class="icon" title="Users">
            <i class="fa-solid fa-users sidebar-icon"></i>
          </div>
          <div class="menu-item" *ngIf="!toggleService.isToggled">Users</div>
        </div>
      </div>
    </div>
    <div id="sidebarTHCopyLink" class="copyright" *ngIf="!toggleService.isToggled">
      ©{{ this.currentYear }} <span class="default-link" (click)="navigateToTH()">TermHub™</span>
      <p>All Rights Reserved</p>
    </div>
  </div>
</div>
